var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0869 13.7364V12.3505C12.0869 11.6154 11.7948 10.9104 11.275 10.3906C10.7552 9.87082 10.0502 9.5788 9.31514 9.5788H3.77171C3.03661 9.5788 2.33161 9.87082 1.81182 10.3906C1.29202 10.9104 1 11.6154 1 12.3505V13.7364",
    stroke: "#17A1FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54344 6.80707C8.07422 6.80707 9.31515 5.56613 9.31515 4.03535C9.31515 2.50458 8.07422 1.26364 6.54344 1.26364C5.01267 1.26364 3.77173 2.50458 3.77173 4.03535C3.77173 5.56613 5.01267 6.80707 6.54344 6.80707Z",
    stroke: "#17A1FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7474002d9b5beb4c259cd84125529488.svg";
export { ForwardRef as ReactComponent };